module.exports = __webpack_public_path__ + "img/아시안.4dcf46f1.png";